import _ from 'lodash';

const getApiGatewayURI = () => {
  switch (process.env.REACT_APP_BE_ENV) {
    case 'dev-01':
      return 'https://api.linearb-dev-01.io';
    case 'dev-02':
      return 'https://api.linearb-dev-02.io';
    case 'dev-03':
      return 'https://api.linearb-dev-03.io';
    case 'staging-01':
      return 'https://api.linearb-staging-01.io';
    default:
      break;
  }

  switch (process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:9090';
    default:
      return `${window.location.protocol}//${window.location.hostname
        .replace('app.', 'api.')
        .replace('app2.', 'api.')
        .replace('app3.', 'api.')}`;
  }
};

export const API_GATEWAY_URI = getApiGatewayURI();

export const LINWEB_URI =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : `${window.location.protocol}//${window.location.hostname}`;

const API_PATHS = {
  CONTRIBUTORS_PATH: 'rest/contributors',
  API_TOKENS_PATH: 'tokens',
  TEAMS_PATH: 'rest/teams',
  GROUPS_PATH: 'rest/groups',
  CONFIGURATION_PATH: 'rest/configuration',
  ACCOUNTS_PATH: 'rest/accounts',
  ACCOUNTS_PERMISSION_DOMAIN_PATH: 'rest/accounts/permission/domain',
  REPOSITORIES_PATH: 'rest/repositories',
  ORGANIZATIONS_PATH: 'rest/organizations',
  TEST_ACCESS_CONNECTIVITY_PATH: 'rest/test-connectivity/access-test',
  TEST_API_TOKEN_PATH: 'rest/test-connectivity/api-test',
  REQUIRED_SCOPES_PATH: 'rest/test-connectivity/required-scopes',
  APP_VALIDATE_PATH: 'rest/test-connectivity/app-validate',
  AUTH_PATH: 'rest/auth',
  SAML_PATH: 'rest/public/auth/identity/saml',
  PREMIUM_REQUEST: 'rest/premium-request',
  SENSOR_AUTHORIZATIONS_PATH: 'rest/sensor-authorizations',
  GITHUB_APP_INSTALL_PATH: 'rest/github-app/install',
  INVITATIONS_PATH: 'rest/invitations',
  PUBLIC_INVITATIONS_PATH: 'rest/public/invitations',
  SENSOR_USER_DETAILS: 'rest/sensors/user-details',
  SENSOR_GIT_TEAMS: 'rest/git-teams',
  SENSOR_GIT_TEAMS_DISTINCTIONS: 'rest/git-teams/distinctions',
  PUBLIC_REQUEST_INVITATION_PATH: 'rest/public/request-invitation',
  JIRA_PATH: 'pm/jira',
  JIRA_AUTH_PATH: 'pm/jira/auth',
  PROVIDER_ENTITIES_PATH: 'pm/provider/entities',
  PROJECTS_PATH: 'pm/projects',
  BOARDS_PATH: 'pm/boards',
  ITERATIONS_PATH: 'pm/iterations',
  ORG_SETTINGS_PATH: 'settings',
  PRS_PATH: 'pull-requests',
  METRICS_SEARCH_PATH: 'metrics/search',
  METRICS_SEARCH_PATH_V2: 'v2/metrics/search',
  METRICS_SEARCH_PATH_V3: 'v3/metrics/search',
  METRICS_SEARCH_INCIDENTS: 'v3/metrics/search/incidents',
  METRICS_SEARCH_PATH_V3_WITH_TOTALS: 'v3/metrics/v2/search',
  CUSTOM_METRICS: 'v1/custom-metrics/list',
  BRANCHES_RAW_V1: 'v1/branches/raw',
  PRS_RAW_V1: 'v1/pull-requests/raw',
  SERVICES_PATH: 'services',
  METRICS_PATH: 'metrics',
  BRANCHES_PATH: 'branches',
  BRANCHES_PATH_V2: 'v2/branches',
  RELEASES_PATH: 'releases',
  INCIDENTS_PATH: 'incidents',
  COMMITS_PATH: 'commits/stats',
  SLACK_PATH: 'rest/slack',
  NOTIFICATIONS_PATH: 'notifications',
  GRAPHQL_API_PATH: 'graphql',
  REPORTS_PATH: 'rest/reports',
  JOBS_SUITES_PATH: 'rest/jobs-suites',
  ISSUES_PATH: 'pm/issues',
  PUBLIC_LINKED_ACCOUNTS: 'rest/public/linked-accounts',
  PM_PROVIDER_SYNC_PATH: 'pm/provider/sync',
  PM_PROJECTS_VIEW: 'pm/projects-view',
  PM_PROVIDER: 'pm/provider',
  LAB_PATH: 'lab',
  DASHBOARDS: 'dashboards',
  MESSAGE_CENTER: 'notification-center',
  AUDIT_PATH: 'audit',
  PDT_ISSUES: 'pm/pdt_issues',
  PDT_PROJECTS: 'pm/pdt-projects',
  PDT_PROJECTS_CONFIG: 'pm/pdt-projects-config',
  PDT_ISSUES_V2_PATH: 'pm/pdt-issues-v2',
  RESOURCE_ALLOCATION: 'pm/resource-allocation',
  INVESTMENT_CARVING_V2: 'pm/pm-projects/investment-carving',
  PROJECT_PROGRESSION: 'pm/pm-projects/project-progression',
  PM_PROJECTS: 'pm/pm-projects',
  PM_PROJECTS_FILTERS: 'pm/pm-projects/filters',
  UNSUBSCRIBE: 'rest/public/unsubscribe',
  PM_DATA: 'pm/pm-data',
  ZERO_BOUNCE: 'rest/zerobounce',
  PUBLIC_MICROFRONTENDS: 'rest/public/microfrontends',
  AUTO_REPO_DISCOVERY_FILTERS: 'repo-auto-discovery-filters',
  ORG_WEBHOOKS: 'rest/org-webhooks',
  FILTER_SET: 'rest/saved-filter-sets',
  VISION: 'vision',
  USERS: 'users',
  TEAMS_V2: 'users/teams'
};

export const API = /** @type {Record<string, string>} */ (
  _(API_PATHS).reduce(
    (acc, val, key) => ({
      ...acc,
      [key]: `${API_GATEWAY_URI}/api/${
        val.match(/[vV][0-9]+[/]/) ? '' : 'v1/'
      }${val}`
    }),
    {}
  )
);

export const LINB_API = {
  TOKEN: {
    REFRESH: `${API_GATEWAY_URI}/api/v1/rest/public/auth/jwt/refresh`,
    LOGOUT: `${API_GATEWAY_URI}/api/v1/rest/public/auth/logout`,
    RENEW: `${API.AUTH_PATH}/jwt/renew`
  },
  PM_SERVICE: {
    STATUSES: `${API.PM_PROVIDER}/meta_data/statuses`,
    LABELS: `${API.PM_PROVIDER}/meta_data/labels`,
    FIX_VERSIONS: `${API.PM_PROVIDER}/meta_data/fix_versions`,
    FIELDS: `${API.PM_PROVIDER}/meta_data/fields`,
    ISSUES: `${API.PM_PROVIDER}/issues/search`,
    ISSUES_COUNT: `${API.PM_PROVIDER}/issues/count`,
    PM_ENTITIES: {
      // entities from DDB, only JIRA and AZURE BOARDS is currently supported
      LABELS: `${API.PM_DATA}/labels`,
      PROJECTS: `${API.PM_DATA}/projects`,
      BOARDS: `${API.PM_DATA}/boards`,
      EPICS: `${API.PM_DATA}/epics`,
      FIX_VERSIONS: `${API.PM_DATA}/fix_versions`,
      ISSUE_TYPES: `${API.PM_DATA}/issue_types`,
      FIELDS: `${API.PM_DATA}/fields`,
      STATUSES: `${API.PM_DATA}/states`,
      PDT_PROJECT_FILTERS: `${API.PM_PROJECTS_VIEW}/projects-filters`
    },
    ENTITIES: {
      JIRA: {
        BOARDS: `${API.PM_PROVIDER}/entities/board`,
        PROJECTS: `${API.PM_PROVIDER}/entities/project`
      },
      SHORTCUT: {
        TEAMS: `${API.PM_PROVIDER}/entities/team`,
        PROJECTS: `${API.PM_PROVIDER}/entities/project`,
        LABELS: `${API.PM_PROVIDER}/entities/labels`,
        EPICS: `${API.PM_PROVIDER}/entities/epic`
      },
      AZURE_BOARDS: {
        PROJECTS: `${API.PM_PROVIDER}/entities/project`,
        TEAMS: `${API.PM_DATA}/teams`,
        AREAS: `${API.PM_DATA}/areas`,
        LABELS: `${API.PM_PROVIDER}/entities/labels`,
        FIELDS: `${API.PM_PROVIDER}/entities/fields`
      }
    }
  },
  RESOURCE_ALLOCATION: {
    WIDGETS: {
      SUMMARY_HEADER: `${API.RESOURCE_ALLOCATION}/widgets/summary-header`,
      AGGREGATED_TABLE: `${API.RESOURCE_ALLOCATION}/widgets/aggregated-table`,
      AGGREGATED_TABLE_EXPORT: `${API.RESOURCE_ALLOCATION}/widgets/aggregated-table-export`,
      OVER_TIME_CHART: `${API.RESOURCE_ALLOCATION}/widgets/over-time-chart`,
      DONUT_CHART: `${API.RESOURCE_ALLOCATION}/widgets/donut-chart`
    },
    ISSUE_STATUS: `${API.RESOURCE_ALLOCATION}/issue-status`,
    AVAILABILITY: `${API.RESOURCE_ALLOCATION}/availability`,
    INVESTMENT_CARVING: `${API.RESOURCE_ALLOCATION}/investment-carving`,
    INVESTMENT_CARVING_CATEGORY_ISSUES: `${API.RESOURCE_ALLOCATION}/investment-carving/category-issues`
  },
  PROJET_PROGRESSION: {
    STATUS: `${API.PROJECT_PROGRESSION}/status`,
    WIDGETS: {
      OVER_TIME_CHART: `${API.PROJECT_PROGRESSION}/widgets/over-time-chart`,
      INSIGHTS: `${API.PROJECT_PROGRESSION}/widgets/insights`,
      PROGRESSION_TABLE: `${API.PROJECT_PROGRESSION}/widgets/aggregated-table`,
      FORECASTING: `${API.PROJECT_PROGRESSION}/widgets/forecasting`
    },
    ISSUES: `${API.PROJECT_PROGRESSION}/entities`
  },
  PM_PROJECTS: {
    FILTERS: {
      ISSUE_TYPES: `${API.PM_PROJECTS_FILTERS}/issue-types`,
      ISSUE_TYPES_BY_IDS: `${API.PM_PROJECTS_FILTERS}/issue-types-by-ids`,
      ENTITIES: `${API.PM_PROJECTS_FILTERS}/entities`
    }
  },
  DASHBOARDS: {
    WIDGETS: `${API.DASHBOARDS}/widgets`
  },
  VISION_AI: {
    ITERATION_SUMMARY: `${API.VISION}/insights`
  },
  USERS_SERVICE: {
    USERS: `${API.USERS}/users`
  },
  TEAMS_V2_SERVICE: {
    TEAMS: `${API.TEAMS_V2}`
  }
};
